import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

const PAGES = [
  { key: "about", label: "About" },
  { key: "technical_service", label: "Technical Service" },
  { key: "contact", label: "Contact (with extras)" },
];

export default function AdminPages() {
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("_all");
  const [selectedPage, setSelectedPage] = useState("about");
  const [form, setForm] = useState({ content: "", extras: {} });

  useEffect(() => {
    api.get("/brands").then((r) => setBrands(r.data));
  }, []);

  useEffect(() => {
    api.get(`/pages/${selectedPage}/${selectedBrand}`).then((r) => {
      setForm({ content: r.data.content || "", extras: r.data.extras || {} });
    });
  }, [selectedBrand, selectedPage]);

  const save = async () => {
    try {
      await api.put(`/pages/${selectedPage}/${selectedBrand}`, {
        key: selectedPage,
        brand_slug: selectedBrand,
        content: form.content,
        extras: form.extras,
      });
      toast.success("Saved");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div data-testid="admin-pages">
      <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Content</div>
      <h1 className="font-display text-4xl tracking-tighter mb-10">Pages Content</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <select value={selectedPage} onChange={(e) => setSelectedPage(e.target.value)} className="adm-input" data-testid="pages-page-select">
          {PAGES.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
        </select>
        <select value={selectedBrand} onChange={(e) => setSelectedBrand(e.target.value)} className="adm-input" data-testid="pages-brand-select">
          <option value="_all">Main Site (All)</option>
          {brands.map((b) => <option key={b.id} value={b.slug}>{b.name}</option>)}
        </select>
      </div>

      <div className="border border-white/10 bg-[#0A0A0A] p-6 mb-6">
        <label className="block text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">Content (plain text)</label>
        <textarea rows={12} value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} className="adm-input" data-testid="pages-content-textarea" />
      </div>

      {selectedPage === "contact" && (
        <div className="border border-white/10 bg-[#0A0A0A] p-6 mb-6">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">Contact Info</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">Phone</label>
              <input value={form.extras.phone || ""} onChange={(e) => setForm({ ...form, extras: { ...form.extras, phone: e.target.value } })} className="adm-input" />
            </div>
            <div>
              <label className="block text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">Email</label>
              <input type="email" value={form.extras.email || ""} onChange={(e) => setForm({ ...form, extras: { ...form.extras, email: e.target.value } })} className="adm-input" />
            </div>
            <div className="md:col-span-2">
              <label className="block text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">Address</label>
              <textarea rows={3} value={form.extras.address || ""} onChange={(e) => setForm({ ...form, extras: { ...form.extras, address: e.target.value } })} className="adm-input" />
            </div>
            <div className="md:col-span-2">
              <label className="block text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">Google Maps Embed (iframe HTML)</label>
              <textarea rows={4} value={form.extras.map_embed || ""} onChange={(e) => setForm({ ...form, extras: { ...form.extras, map_embed: e.target.value } })} className="adm-input font-mono text-xs" />
            </div>
          </div>
        </div>
      )}

      <button onClick={save} className="brand-btn px-6 py-3 text-xs uppercase tracking-[0.2em]" data-testid="pages-save-btn">Save</button>
      <style>{`.adm-input { width: 100%; background: #141414; border: 1px solid rgba(255,255,255,0.1); padding: 0.625rem 0.875rem; font-size: 0.875rem; color: white; outline: none; } .adm-input:focus { border-color: rgba(255,255,255,0.3); }`}</style>
    </div>
  );
}
